
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Skeleton } from "../../Components/Skeleton.js";
import { toList, empty, singleton, append, delay, toArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Table } from "../../Widgets/Table/Table.js";
import { singleton as singleton_1, toArray as toArray_1, ofArray, empty as empty_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_encodeQueryString, RouterModule_nav, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, init as init_1 } from "./State.js";
import { withoutOnboardingTourQueryParams, isManageStoragesTourOverviewPhase } from "../../Common.js";
import { Button } from "../../Components/Button.js";
import { TourGuideLocale, TourStep, TourGuide } from "../../Components/TourGuide.js";

export function StorageOverviewTable(props) {
    let elems;
    const t = useTranslation()[0];
    const matchValue = props.State.Storages;
    const matchValue_1 = props.State.AccountSettings;
    let matchResult, accountSettings, storages;
    if (matchValue.tag === 1) {
        if (matchValue_1.tag === 1) {
            matchResult = 1;
            accountSettings = matchValue_1.fields[0];
            storages = matchValue.fields[0];
        }
        else {
            matchResult = 0;
        }
    }
    else {
        matchResult = 0;
    }
    switch (matchResult) {
        case 0:
            return createElement(Skeleton, {
                Variant: "table",
            });
        default: {
            const columnDefinitions = toArray(delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("Description", "", t("general.description"), (dto_1) => (new CellContent(0, [dto_1.Description])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("Location", "", t("general.location"), (dto_2) => (new CellContent(0, [defaultArg(dto_2.LocationName, "–")])), "locationSelect", "text")), delay(() => (accountSettings.BusinessUnitsEnabled ? singleton(new ColumnDefinition$1("businessUnitName", "", t("business_units.business_unit"), (dto_3) => (new CellContent(0, [defaultArg(dto_3.BusinessUnitName, "")])), "select", "text")) : empty())))))))));
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, {
                ColumnDefinitions: columnDefinitions,
                Controls: empty_1(),
                Options: {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["name", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    OnRowClick: new OnTableRowClick$1(1, [(dto_4) => RouterModule_encodeParts(ofArray(["storages", unwrapStorageId(dto_4.Id)]), 1)]),
                    RowSelection: "disabled",
                    SaveTableConfiguration: false,
                },
                TableKey: "not-defined-table",
                TableRows: toArray_1(storages),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }
    }
}

export function Container() {
    let elems_2, elems_1, elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "align-text-middle"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["pr-4"])], (elems = [createElement(TabsMenu, {
        Tabs: ofArray([{
            IsSelected: true,
            Label: t("navbar.storages"),
            OnClick: () => {
                RouterModule_nav(ofArray(["storages"]), 1, 1);
            },
            TestId: "overview-tab-storages",
        }, {
            IsSelected: false,
            Label: t("navbar.locations"),
            OnClick: () => {
                RouterModule_nav(ofArray(["locations"]), 1, 1);
            },
            TestId: "overview-tab-locations",
        }]),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function StoragesOverview() {
    let elems_2;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const t = useTranslation()[0];
    const patternInput_2 = reactApi.useState(false);
    const setManageStoragesOverviewTourDismissed = patternInput_2[1];
    const showManageStoragesOverviewTour = isManageStoragesTourOverviewPhase() && !patternInput_2[0];
    return reactElement("div", createObj(ofArray([["id", "storage-container"], ["className", join(" ", [])], (elems_2 = toList(delay(() => {
        let elems_1, elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "mb-5", "items-center"])], (elems_1 = [createElement(Container, null), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("storage.create_new_storage"),
            OnClick: () => {
                RouterModule_nav(ofArray(["storages", "new"]), 1, 1);
            },
            TestId: "new-storage-button",
            Variant: "primary",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => append(singleton(createElement(StorageOverviewTable, {
            State: patternInput[0],
        })), delay(() => {
            let Steps;
            return showManageStoragesOverviewTour ? singleton(createElement(TourGuide, (Steps = singleton_1(new TourStep("[data-test-id=\'new-storage-button\']", t("onboarding.tour.storage_overview_create_title"), reactElement("div", {
                children: t("onboarding.tour.storage_overview_create_content"),
            }), "bottom", true)), {
                IsRunning: true,
                Locale: new TourGuideLocale(t("onboarding.tour.joyride_back"), t("onboarding.tour.joyride_close"), t("onboarding.tour.joyride_last"), t("onboarding.tour.joyride_next"), t("onboarding.tour.joyride_next_with_progress"), t("onboarding.tour.joyride_open"), t("onboarding.tour.joyride_skip")),
                OnFinish: () => {
                    setManageStoragesOverviewTourDismissed(true);
                    RouterModule_nav(ofArray(["storages", "new" + RouterModule_encodeQueryString(singleton_1(["onboardingTourStep", "manage-storages-step"]))]), 1, 1);
                },
                OnSkip: () => {
                    setManageStoragesOverviewTourDismissed(true);
                    RouterModule_nav(singleton_1("storages" + RouterModule_encodeQueryString(withoutOnboardingTourQueryParams())), 1, 1);
                },
                ScrollFirstStep: true,
                Steps: Steps,
            }))) : empty();
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

